/* eslint-disable jsx-a11y/anchor-is-valid */
import { Text } from '@react-pdf/renderer';
import styles, { pdfDisclaimerFontSize } from '../pro-report-pdf-styles';

function Disclaimer() {
  return (
    <Text style={{ ...styles.section, fontSize: pdfDisclaimerFontSize }}>
      The purpose of this report is to provide a source of information which is
      additional to that available to the maritime industry from regulatory,
      advisory, and consultative organisations. Whilst care is taken to ensure
      the accuracy of any information made available no warranty of accuracy is
      given and users of that information are to be responsible for satisfying
      themselves that the information is relevant and suitable for the purposes
      to which it is applied. In no circumstances whatsoever shall NorthStandard
      be liable to any person whatsoever for any loss or damage whensoever or
      howsoever arising out of or in connection with the supply (including
      negligent supply) or use of information. Unless the contrary is indicated,
      all articles are written with reference to English Law. However it should
      be noted that the content of this report does not constitute legal advice
      and should not be construed as such. Members should contact NorthStandard
      for specific advice on particular matters.
    </Text>
  );
}

export default Disclaimer;
